import { BACKEND_URL } from "@/lib/backendUrl";
import axios from "axios";

export const APPRENTICE_TOKEN_KEY = "servecor_apprentice_token";

export const apprenticeApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

apprenticeApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(APPRENTICE_TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
